var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content md flex-box justify-center"},[_c('form-area',{ref:"detailForm",staticClass:"password-form",attrs:{"layout":"horizontal","confirm-text":"修改","label-col":{span: 6},"wrapper-col":{span: 18},"items":_vm.items,"entity":_vm.form},on:{"cancel":function($event){return _vm.cancel()},"confirm":_vm.modify}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }